{
  "date": "Date",
  "email": "Email",
  "lastName": "Last name",
  "name": "Name",
  "firstName": "First name",
  "description": "Description",
  "gender": "Gender",
  "missing_src": "Missing source file",
  "image_not_found": "Image not found",
  "new": "new",
  "order_by": "Order by",
  "update": "Update",
  "submit": "Submit",
  "cancel": "Cancel",
  "delete": "Delete",
  "videoSnapShot_not_found": "No thumbnail available",
  "delete_item": "Delete item",
  "fieldRequired": "Field is required",
  "fieldMin": "Field must be at least {{min}} characters",
  "fieldMax": "Field must be {{max}} characters at most",
  "fileRequired": "File is required",
  "min_value": "The minimum value should be {{min}}",
  "password_confirm": "Passwords are not the same",
  "image_dimensions_error": "The dimensions of this image are to big, Max dimensions: {{what}}",
  "show_all": "Show all",
  "show_completed": "Show completed",
  "wrong_email_error": "Please enter a valid email",
  "wrong_phone_error": "Please enter a valid phone number",
  "enter_at_least_phone": "Please enter at least either phone number or email",
  "enter_at_least_email": "Please enter at least either email or phone number",
  "itemWithCount_one": "{{count}} item",
  "itemWithCount_other": "{{count}} items",
  "strip_one": "Strip",
  "strip_other": "Strips",
  "personWithCount_one": "{{count}} person",
  "personWithCount_other": "{{count}} persons",
  "year_one": "{{count}} year",
  "year_other": "{{count}} years",
  "month_one": "{{count}} month",
  "month_other": "{{count}} months",
  "day_one": "{{count}} day",
  "day_other": "{{count}} days",
  "isAny_one": "is",
  "isAny_other": "is any of",
  "project": "Project",
  "projects": "Projects",
  "projectWithCount_one": "{{count}} Project",
  "projectWithCount_other": "{{count}} Projects",
  "status": "Status",
  "statuses": "Statuses",
  "statusWithCount_one": "{{count}} Status",
  "statusWithCount_other": "{{count}} Statuses",
  "assignee": "Assignee",
  "assignees": "Assignees",
  "assigneeWithCount_one": "{{count}} Assignee",
  "assigneeWithCount_other": "{{count}} Assignees",
  "priority": "Priority",
  "priorities": "Priorities",
  "priorityWithCount_one": "{{count}} Priority",
  "priorityWithCount_other": "{{count}} Priorities",
  "tag": "Tag",
  "tags": "Tags",
  "tagWithCount_one": "{{count}} Tag",
  "tagWithCount_other": "{{count}} Tags",

  "storage-limit-title": "Storage limit exceeded",
  "storage-limit-description": "Your upload could not be completed due to insufficient storage. You have the option to book additional storage or upgrade your plan.",
  "duplicate-storage-title": "Storage limit exceeded",
  "duplicate-storage-description": "This project cannot be duplicated because of insufficient storage.",
  "duplicate-tasks-title": "Tasks limit exceeded",
  "duplicate-tasks-description": "This project cannot be duplicated because it would exceed the plan's limit of {{limit}} tasks."
}
